export default __webpack_public_path__ + "static/media/KOD0106-min.e630c81e.webp";